export default {"src":"/_next/static/media/situation-violence.cae32168.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};